/* Progressive cart navigation. Kaching and DingDoong retain every purchase control. */
(() => {
  'use strict';
  if (document.body.classList.contains('template-cart-redesign')) return;

  const calendarSelector = '.ot-dingdoong-day-picker-container .ot-dingdoong-dropdown__button';
  let cart = null;
  let step = 'products';
  let contentObserver = null;
  let stateObserver = null;
  let queued = false;

  function text(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }
  function attr(node, name, value) {
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  }
  function nativeCopy(node, match, replacement) {
    if (!node) return;
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const leaf = walker.currentNode;
      if (match.test(leaf.nodeValue)) leaf.nodeValue = leaf.nodeValue.replace(match, replacement);
    }
  }
  function ui(tag, className) {
    const node = document.createElement(tag);
    node.className = className;
    node.dataset.jCartUi = '';
    return node;
  }
  function button(className, label) {
    const node = ui('button', className);
    node.type = 'button';
    node.textContent = label;
    return node;
  }

  function setStep(next, focus = true) {
    if (!cart?.classList.contains('j-cart-flow-ready')) return;
    if (next === 'products' && cart.querySelector(calendarSelector)?.getAttribute('aria-expanded') === 'true') {
      cart.querySelector(calendarSelector).click();
    }
    step = next;
    update();
    if (!focus) return;
    const target = next === 'shipping'
      ? cart.querySelector('.j-cart-flow-intro h2')
      : cart.querySelector('[data-j-cart-step="products"]');
    if (next === 'shipping') cart.querySelector('.kaching-cart__footer').scrollTop = 0;
    target?.focus({ preventScroll: true });
  }

  function navigation(header, physical) {
    const nativeHeading = header.querySelector('.kaching-cart__heading');
    let title = header.querySelector('.j-cart-title');
    if (!title && nativeHeading) {
      title = ui('div', 'j-cart-title');
      const name = document.createElement('h2');
      name.textContent = 'Dein Warenkorb';
      const count = document.createElement('span');
      count.className = 'j-cart-count';
      title.append(name, count);
      nativeHeading.insertAdjacentElement('beforebegin', title);
    }
    const count = nativeHeading?.textContent.match(/[•·]\s*(\d+)x\s*$/)?.[1];
    text(title?.querySelector('.j-cart-count'), count ? `${count} Artikel` : '');
    let nav = cart.querySelector('.j-cart-flow-nav');
    if (!nav) {
      nav = ui('nav', 'j-cart-flow-nav');
      nav.setAttribute('aria-label', 'Schritte im Warenkorb');
      const products = button('j-cart-flow-tab', '');
      const productDot = document.createElement('span');
      productDot.className = 'j-cart-step-dot';
      productDot.setAttribute('aria-hidden', 'true');
      const productLabel = document.createElement('span');
      productLabel.textContent = 'Produkte prüfen';
      products.append(productDot, productLabel);
      products.dataset.jCartStep = 'products';
      products.addEventListener('click', () => setStep('products'));
      const shipping = button('j-cart-flow-tab', '');
      const shippingDot = productDot.cloneNode();
      const shippingLabel = document.createElement('span');
      shippingLabel.className = 'j-cart-step-label';
      shippingLabel.textContent = 'Versand & Kasse';
      shipping.append(shippingDot, shippingLabel);
      shipping.dataset.jCartStep = 'shipping';
      shipping.addEventListener('click', () => setStep('shipping'));
      nav.append(products, shipping);
      header.insertAdjacentElement('afterend', nav);
    }
    text(nav.querySelector('.j-cart-step-label'), physical ? 'Versand & Kasse' : 'Zur Kasse');
    attr(nav.querySelector('[data-j-cart-step="products"]'), 'data-complete', String(step === 'shipping'));
    nav.querySelectorAll('[data-j-cart-step]').forEach(control => {
      if (control.dataset.jCartStep === step) attr(control, 'aria-current', 'step');
      else control.removeAttribute('aria-current');
    });
  }

  function productPresentation(items) {
    items.forEach(item => {
      const info = item.querySelector('.kaching-cart-item__info');
      const left = item.querySelector('.kaching-cart-item__content-left');
      const right = item.querySelector('.kaching-cart-item__content-right');
      const properties = item.querySelectorAll('.kaching-cart-item__property-option');
      const knownInfo = info && [...info.children].every(node => node.matches('.kaching-cart-item__title,.kaching-cart-item__option-names,.kaching-cart-item__variant-selectors,.kaching-cart-item__property-option'));
      const knownLeft = left && [...left.children].every(node => node.matches('.kaching-cart-item__info,.kaching-cart-item__quantity-controls'));
      const knownRight = right && [...right.children].every(node => node.matches('.kaching-cart-item__price-info,.kaching-cart-item__remove-btn'));
      const compact = item.dataset.hasSellingPlan !== 'true' && knownInfo && knownLeft && knownRight
        && item.querySelector('.kaching-cart-item__quantity-controls') && item.querySelectorAll('select').length <= 1 && properties.length <= 1;
      if (compact) attr(item, 'data-j-cart-compact', '');
      else item.removeAttribute('data-j-cart-compact');
      if (compact && properties.length) attr(item, 'data-j-cart-properties', '');
      else item.removeAttribute('data-j-cart-properties');
      nativeCopy(item.querySelector('.kaching-cart-item__property-label'), /^Einzeln Verpacken:\s*$/, 'Einzeln verpacken:');
    });
  }

  function footerControls(footer, physical) {
    let intro = footer.querySelector('.j-cart-flow-intro');
    if (!intro) {
      intro = ui('div', 'j-cart-flow-intro');
      const heading = document.createElement('h2');
      heading.tabIndex = -1;
      const explanation = document.createElement('p');
      explanation.className = 'j-cart-flow-explanation';
      intro.append(heading, explanation);
      footer.prepend(intro);
    }
    text(intro.querySelector('h2'), physical ? 'Dein Versandtag.' : 'Deine Bestellung.');
    text(intro.querySelector('.j-cart-flow-explanation'), physical
      ? 'Du wählst den Versandtag. Die Zustellung folgt regulär 1–2 Werktage später.'
      : 'Prüfe deine Auswahl. Deinen Rabattcode kannst du hier eingeben.');

    let actions = footer.querySelector('.j-cart-flow-actions');
    if (!actions) {
      actions = ui('div', 'j-cart-flow-actions');
      const next = button('j-cart-flow-next', 'Weiter zum Versand');
      next.addEventListener('click', () => setStep('shipping'));
      const hint = document.createElement('p');
      actions.append(next, hint);
      footer.append(actions);
    }
    text(actions.querySelector('button'), physical ? 'Weiter zum Versand →' : 'Weiter zur Kasse →');
    text(actions.querySelector('p'), physical ? 'Versandtag & Rabattcode im nächsten Schritt' : 'Rabattcode im nächsten Schritt');

    // Only replace the app's initial instruction; selected dates and app errors remain native.
    const title = footer.querySelector('.ot-dingdoong-header__title');
    if (title && /^Wähle den Versandtag \(1-2 Werktage Versand\)\s*$/.test(title.textContent)) {
      nativeCopy(title, /^Wähle den Versandtag \(1-2 Werktage Versand\)\s*$/, 'Versandtag wählen');
      title.dataset.jCartRepeat = '';
    }
    const label = footer.querySelector('.ot-dingdoong-day-picker__label');
    nativeCopy(label, /^Versanddatum \(der Tag an dem wir das Paket dem Paketdienst übergeben\)\s*$/, 'Versandtag wählen');
    const placeholder = footer.querySelector('.ot-dingdoong-calendar__popover-button > span');
    nativeCopy(placeholder, /^Versanddatum \(danach 1\s*-\s*2 Werktage\)\s*$/, 'Versandtag wählen');
    const checkoutLabel = footer.querySelector('.kaching-cart__checkout-button-label');
    nativeCopy(checkoutLabel, /^Zum Checkout/, 'Zur Kasse');
  }

  // DingDoong currently requires a date even for Shopify digital gift cards.
  // Keep its physical checkout untouched. The narrow digital route validates
  // Shopify's current cart again immediately before entering hosted checkout.
  const digitalGiftProductId = 8799018942811;
  function isDigitalGiftCart(value) {
    return value?.requires_shipping === false && value.items?.length > 0
      && value.items.every(item => item.requires_shipping === false
        && item.gift_card === true && Number(item.product_id) === digitalGiftProductId);
  }
  function digitalCheckout(footer, items) {
    const eligible = items.length > 0 && items.every(item => item.dataset.requiresShipping === 'false'
      && Number(item.dataset.productId) === digitalGiftProductId);
    cart.classList.toggle('j-cart-digital-only', eligible);
    let panel = footer.querySelector('.j-cart-digital-checkout');
    if (!eligible) { panel?.remove(); return; }
    if (panel) return;
    panel = ui('div', 'j-cart-digital-checkout');
    const note = document.createElement('p');
    note.className = 'j-cart-digital-note';
    note.textContent = 'Dein Gutschein kommt per E-Mail. Du brauchst keinen Versandtag auszuwählen.';
    const checkout = button('j-cart-digital-button', 'Zur Kasse →');
    const status = document.createElement('p');
    status.className = 'j-cart-digital-status';
    status.setAttribute('role', 'status');
    checkout.addEventListener('click', async () => {
      if (checkout.disabled) return;
      checkout.disabled = true;
      text(status, 'Dein Warenkorb wird geprüft …');
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('cart unavailable');
        const latest = await response.json();
        if (!isDigitalGiftCart(latest)) {
          // Reload native cart state if another tab or a pending update added meat.
          text(status, 'Dein Warenkorb hat sich geändert. Wir laden deine Auswahl neu.');
          window.location.reload();
          return;
        }
        // Do not carry a former physical order's date into this digital order.
        // Only DingDoong's known scheduling attributes are cleared at checkout;
        // cart discounts, notes, line properties and other attributes stay native.
        const destination = new URL(`${root}checkout`, window.location.origin);
        ['ot_channel', 'ot_location_id', 'delivery_date_origin', 'Shipping date',
          'Shipping time', 'Checkout channel'].forEach(key => {
          if (Object.prototype.hasOwnProperty.call(latest.attributes || {}, key))
            destination.searchParams.set(`attributes[${key}]`, '');
        });
        window.location.assign(destination.href);
      } catch (_) {
        text(status, 'Die Prüfung hat nicht geklappt. Bitte versuche es erneut.');
        checkout.disabled = false;
      }
    });
    panel.append(note, checkout, status);
    footer.append(panel);
  }

  function orderReview(footer, items) {
    let review = footer.querySelector('.j-cart-order-review');
    if (!review) {
      review = ui('div', 'j-cart-order-review');
      const heading = document.createElement('div');
      heading.className = 'j-cart-order-review__heading';
      const title = document.createElement('strong');
      title.textContent = 'Deine Auswahl';
      const edit = button('j-cart-order-edit', 'Ändern');
      edit.setAttribute('aria-label', 'Produktauswahl ändern');
      edit.addEventListener('click', () => setStep('products'));
      heading.append(title, edit);
      const list = document.createElement('ul');
      review.append(heading, list);
      footer.prepend(review);
    }
    const rows = items.map(item => {
      const name = item.querySelector('.kaching-cart-item__title')?.textContent.trim() || '';
      const quantity = item.querySelector('.kaching-cart-item__quantity-input')?.value;
      const choices = [...item.querySelectorAll('select')].map(el => el.selectedOptions[0]?.textContent.trim()).filter(Boolean);
      const price = item.querySelector('.kaching-cart-item__total-final')?.textContent.trim() || '';
      return { name, quantity, choices, price };
    });
    const signature = JSON.stringify(rows);
    if (review.dataset.selection === signature) return;
    review.dataset.selection = signature;
    const list = review.querySelector('ul');
    list.replaceChildren();
    rows.slice(0, 3).forEach(row => {
      const line = document.createElement('li');
      const label = document.createElement('span');
      label.textContent = `${row.quantity ? row.quantity + ' × ' : ''}${row.name}${row.choices.length ? ' · ' + row.choices.join(' / ') : ''}`;
      const amount = document.createElement('span');
      amount.textContent = row.price;
      line.append(label, amount);
      list.append(line);
    });
    if (rows.length > 3) {
      const line = document.createElement('li');
      line.textContent = `+ ${rows.length - 3} weitere Positionen unter „Produkte prüfen“`;
      list.append(line);
    }
  }

  function orderFooter(footer) {
    // Reuse the same controls in the same app footer; match reading and keyboard order to the design.
    const selectors = ['.j-cart-order-review', '.j-cart-flow-intro', '[id^="ot-dingdoong"]', '.r-cart-calendar-status',
      '.r-kaching-discount-panel', '.r-premium-cart-trust', '.kaching-cart__cart-discounts',
      '.kaching-cart__subtotal', '.kaching-cart__checkout-button', '.j-cart-digital-checkout', '.j-cart-flow-actions'];
    const ordered = selectors.map(selector => footer.querySelector(`:scope > ${selector}`)).filter(Boolean);
    const current = [...footer.children].filter(node => ordered.includes(node));
    if (current.every((node, index) => node === ordered[index])) return;
    ordered.forEach(node => footer.append(node));
  }

  function disclosures(physical) {
    const bar = cart.querySelector('.kaching-cart__tiered-promotions-bar');
    const status = bar?.querySelector('.kaching-cart__tiered-promotions-bar-text');
    if (bar && status && bar.querySelector('.kaching-cart__tiered-promotions-bar-progress-container')) {
      let summary = bar.querySelector('.j-cart-progress-summary');
      if (!summary) {
        summary = ui('p', 'j-cart-progress-summary');
        bar.prepend(summary);
        bar.classList.add('j-cart-progress-ready');
        bar.closest('.kaching-cart__module')?.classList.add('j-cart-progress-module');
      }
      const present = value => value.replace(/\s+/g, ' ').trim().replace(/\bGRATIS\b/g, 'Gratis').replace(/(\d+)\s?g\b/g, '$1\u00a0g').replace(/!\s+/g, ' · ').replace(/!$/, '').replace(/\s*·\s*$/, '').trim();
      text(summary, present(status.textContent));
      const states = [...bar.querySelectorAll('.kaching-cart__tiered-promotions-bar-icon')];
      bar.querySelectorAll('.r-kaching-progress-labels span').forEach((label, index) => {
        const narrow = bar.getBoundingClientRect().width < 440;
        text(label, narrow ? present(label.textContent).replace(/^Gratis\s+/i, '') : present(label.textContent));
        attr(label, 'data-reached', String(states[index]?.classList.contains('kaching-cart__tiered-promotions-bar-icon--unlocked') || false));
      });
      // Labels sit under their tier marker; each label keeps to its half-way
      // boundaries towards the neighbouring markers, so labels never touch.
      const labelRow = bar.querySelector('.r-kaching-progress-labels');
      const labels = [...bar.querySelectorAll('.r-kaching-progress-labels span')];
      if (labelRow && labels.length === states.length && labels.length) {
        const row = labelRow.getBoundingClientRect();
        if (row.width > 0) {
          labelRow.classList.add('j-progress-labels-placed');
          const centers = states.map(state => { const dot = state.getBoundingClientRect(); return dot.left + dot.width / 2 - row.left; });
          labels.forEach((label, index) => {
            const min = index ? (centers[index - 1] + centers[index]) / 2 + 5 : 0;
            const max = index < centers.length - 1 ? (centers[index] + centers[index + 1]) / 2 - 5 : row.width;
            label.style.setProperty('--j-label-width', 'max-content');
            const natural = label.getBoundingClientRect().width;
            const width = Math.min(natural, max - min);
            const left = Math.max(min, Math.min(max - width, centers[index] - width / 2));
            label.style.setProperty('--j-label-left', `${Math.round(left)}px`);
            label.style.setProperty('--j-label-width', `${Math.floor(width)}px`);
            attr(label, 'data-align', index === labels.length - 1 && left + width >= row.width - 1 ? 'end' : 'center');
          });
        }
      }
      cart.querySelectorAll('.kaching-promotion-item__price-final').forEach(node => {
        if (/kostenlos/i.test(node.textContent)) text(node, 'Gratis');
      });
      // Gift rows: Kaching keeps its own stored image; use the same studio photo as the shop.
      let photos = null;
      try { photos = JSON.parse(document.getElementById('j-cart-original-images')?.textContent || 'null'); } catch (_) { photos = null; }
      if (photos) cart.querySelectorAll('.kaching-promotion-item').forEach(item => {
        const handle = item.querySelector('a[href*="/products/"]')?.getAttribute('href')?.match(/\/products\/([^/?#]+)/)?.[1];
        const image = item.querySelector('.kaching-promotion-item__image');
        const photo = handle && photos[handle];
        if (image && photo && image.getAttribute('src') !== photo) { image.removeAttribute('srcset'); image.setAttribute('src', photo); }
      });
    }

    const offers = cart.querySelector('.kaching-upsell-module--product-upsell');
    if (offers?.querySelector('.kaching-cart__carousel')) {
      let toggle = offers.querySelector('.j-cart-offers-toggle');
      if (!toggle) {
        toggle = button('j-cart-offers-toggle', 'Passend dazu');
        toggle.setAttribute('aria-expanded', 'false');
        const carousel = offers.querySelector('.kaching-cart__carousel');
        carousel.id = 'j-cart-offer-choices';
        toggle.setAttribute('aria-controls', carousel.id);
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(expanded));
          offers.classList.toggle('j-cart-offers-open', expanded);
        });
        offers.prepend(toggle);
        offers.classList.add('j-cart-offers-ready');
      }
    }

    const trust = cart.querySelector('.r-premium-cart-trust');
    if (trust) trust.hidden = !physical;
    if (trust && !trust.querySelector('.j-cart-trust-toggle')) {
      const body = ui('div', 'j-cart-trust-body');
      body.id = 'j-cart-trust-body';
      body.hidden = true;
      const promise = trust.querySelector('strong');
      if (promise) promise.classList.add('j-cart-trust-promise');
      body.append(...[...trust.childNodes].filter(node => node !== promise));
      const toggle = button('j-cart-trust-toggle', 'Versandkosten & Hilfe +');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', body.id);
      toggle.addEventListener('click', () => {
        body.hidden = !body.hidden;
        toggle.setAttribute('aria-expanded', String(!body.hidden));
        text(toggle, body.hidden ? 'Versandkosten & Hilfe +' : 'Versandkosten & Hilfe −');
      });
      trust.append(toggle, body);
    }
  }

  // Gap filler: the shop's most frequent order partners (Shopify orders, 12 months),
  // sized to close the distance to the next Kaching reward where that is sensible.
  const fillPartners = ['rinderhackfleisch', 'putenschnitzel', 'hahnchenbrust', 'ochsenfetzen', 'onglet-vom-rind', 'schweineschnitzel', 'rib-eye'];
  const fillProducts = new Map();
  let fillLoading = null;
  const money = cents => (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  function loadFillProducts() {
    if (!fillLoading) {
      const root = window.Shopify?.routes?.root || '/';
      fillLoading = Promise.all(fillPartners.map(handle => fetch(`${root}products/${handle}.js`, { headers: { Accept: 'application/json' } })
        .then(response => (response.ok ? response.json() : null)).catch(() => null)
        .then(product => { if (product) fillProducts.set(handle, product); })))
        .then(() => schedule());
    }
    return fillProducts.size > 0;
  }
  function fillChoices(handles, gap) {
    const bridgeable = gap > 0 && gap <= 6000;
    return fillPartners.filter(handle => !handles.has(handle) && fillProducts.has(handle)).map((handle, rank) => {
      const variants = fillProducts.get(handle).variants.filter(variant => variant.available).sort((a, b) => a.price - b.price);
      if (!variants.length) return null;
      const bridge = bridgeable ? variants.find(variant => variant.price >= gap) : null;
      const variant = bridge || variants.reduce((best, next) => (Math.abs(next.price - 2000) < Math.abs(best.price - 2000) ? next : best));
      return { handle, rank, variant, bridges: Boolean(bridge) };
    }).filter(Boolean).sort((a, b) => (b.bridges - a.bridges) || (a.bridges ? a.variant.price - b.variant.price : 0) || a.rank - b.rank).slice(0, 2);
  }
  function fillGap(items, physical) {
    const offers = cart.querySelector('.kaching-upsell-module--product-upsell');
    const host = offers || items[items.length - 1]?.closest('.kaching-cart__module');
    let fill = cart.querySelector('.j-cart-fill');
    if (!physical || !host || !loadFillProducts()) {
      fill?.remove();
      return;
    }
    const status = cart.classList.contains('j-cart-shipping-included') ? '' : cart.querySelector('.kaching-cart__tiered-promotions-bar-text')?.textContent.replace(/[⁦-⁩]/g, '').replace(/\s+/g, ' ').trim() || '';
    const amount = status.match(/([\d.]+,\d{2})/);
    const gap = amount ? Math.round(parseFloat(amount[1].replace(/\./g, '').replace(',', '.')) * 100) : 0;
    const reward = (status.match(/\d,\d{2}\s*(?:€\s*)?(?:zum|bis zum|bis|für)\s+(.+?)!?$/)?.[1] || '')
      .replace(/^Freiversand$/i, 'Gratisversand').replace(/\bGRATIS\b/g, 'Gratis').replace(/(\d+)\s?g\b/g, '$1 g');
    const handles = new Set(items.map(item => item.querySelector('a[href*="/products/"]')?.getAttribute('href')?.match(/\/products\/([^/?#]+)/)?.[1]).filter(Boolean));
    const choices = fillChoices(handles, gap);
    if (!choices.length) {
      fill?.remove();
      return;
    }
    const bridges = gap > 0 && reward && choices.every(choice => choice.bridges);
    const signature = JSON.stringify([gap, reward, choices.map(choice => choice.variant.id)]);
    if (!fill || fill.parentElement !== host) {
      fill?.remove();
      fill = ui('div', 'j-cart-fill');
      host.append(fill);
    }
    if (fill.dataset.signature === signature) return;
    fill.dataset.signature = signature;
    let photos = null;
    try { photos = JSON.parse(document.getElementById('j-cart-original-images')?.textContent || 'null'); } catch (_) { photos = null; }
    const title = document.createElement('p');
    title.className = 'j-cart-fill__title';
    title.textContent = gap > 0 && reward ? `Noch ${money(gap)} bis ${reward}` : 'Oft mitbestellt';
    const note = document.createElement('p');
    note.className = 'j-cart-fill__note';
    note.textContent = bridges
      ? `Oft mitbestellt – mit einem davon ist ${/versand/i.test(reward) ? 'der Gratisversand' : `„${reward}“`} erreicht.`
      : 'Diese Stücke landen bei uns am häufigsten mit im Warenkorb.';
    const list = document.createElement('ul');
    list.className = 'j-cart-fill__list';
    choices.forEach(({ handle, variant }) => {
      const product = fillProducts.get(handle);
      const size = variant.title === 'Default Title' ? '' : variant.title.replace(/(\d+)\s?g\b/g, '$1 g');
      const row = document.createElement('li');
      row.className = 'j-cart-fill__item';
      const image = document.createElement('img');
      image.src = photos?.[handle] || product.featured_image || '';
      image.alt = '';
      image.width = 56;
      image.height = 56;
      image.loading = 'eager';
      const info = document.createElement('a');
      info.className = 'j-cart-fill__info';
      info.href = product.url || `/products/${handle}`;
      const name = document.createElement('span');
      name.className = 'j-cart-fill__name';
      name.textContent = product.title;
      const meta = document.createElement('span');
      meta.className = 'j-cart-fill__meta';
      meta.textContent = [size, money(variant.price)].filter(Boolean).join(' · ');
      info.append(name, meta);
      const add = button('j-cart-fill__add', 'Hinzufügen');
      add.setAttribute('aria-label', `${product.title}${size ? ' ' + size : ''} für ${money(variant.price)} hinzufügen`);
      add.addEventListener('click', async () => {
        if (add.disabled) return;
        add.disabled = true;
        text(add, '…');
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) });
          if (!response.ok) throw new Error('add failed');
        } catch (_) {
          add.disabled = false;
          text(add, 'Erneut versuchen');
        }
      });
      row.append(image, info, add);
      list.append(row);
    });
    fill.replaceChildren(title, note, list);
  }

  function update() {
    if (!cart?.isConnected) return;
    const items = [...cart.querySelectorAll('.kaching-cart-item')];
    const header = cart.querySelector('.kaching-cart__header');
    const footer = cart.querySelector('.kaching-cart__footer');
    const contents = cart.querySelector('.kaching-cart__contents');
    const eligible = items.length > 0 && header && footer && contents && footer.querySelector('.kaching-cart__checkout-button');
    if (!eligible) {
      cart.classList.remove('j-cart-flow-ready', 'j-cart-digital-only');
      cart.querySelector('.j-cart-digital-checkout')?.remove();
      step = 'products';
      return;
    }
    const physical = items.some(item => item.dataset.requiresShipping !== 'false');
    navigation(header, physical);
    productPresentation(items);
    footerControls(footer, physical);
    orderReview(footer, items);
    digitalCheckout(footer, items);
    disclosures(physical);
    fillGap(items, physical);
    orderFooter(footer);
    if (!cart.classList.contains('j-cart-flow-ready')) cart.classList.add('j-cart-flow-ready');
    attr(cart, 'data-j-cart-view', step);
  }

  function bind() {
    const next = document.getElementById('kaching-cart');
    if (next !== cart) {
      contentObserver?.disconnect();
      stateObserver?.disconnect();
      cart = next;
      step = 'products';
      if (!cart) return;
      contentObserver = new MutationObserver(records => {
        if (records.some(record => !record.target.parentElement?.closest('[data-j-cart-ui]') && !record.target.closest?.('[data-j-cart-ui]'))) schedule();
      });
      contentObserver.observe(cart, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-requires-shipping'] });
      stateObserver = new MutationObserver(() => {
        if (!cart.classList.contains('active') && cart.dataset.rKachingOpen === undefined) setStep('products', false);
      });
      stateObserver.observe(cart, { attributes: true, attributeFilter: ['class'] });
    }
    update();
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; bind(); });
  }
  document.addEventListener('jaesa:cart-state-change', event => {
    if (event.detail?.isOpen === false) setStep('products', false);
    else schedule();
  });
  const mountObserver = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.id === 'kaching-cart' || node.querySelector?.('#kaching-cart'))))) schedule();
  });
  mountObserver.observe(document.body, { childList: true, subtree: true });
  bind();
})();
